/*
 * Functionality for addicition cycle phases
 * components/addition-cycle.njk
 *
 * Triggers for expand/collapse on each of the phases.
 */

import PL_utils from './vendor/pl-utils.js';
import accordion from './vendor/accordion.js';

const addictionPhasesAllEle = document.querySelectorAll('.addiction-cycle__phase');

const applyActiveClass = (element) => {
    const currentEleIndex = [].indexOf.call(addictionPhasesAllEle, element);

    addictionPhasesAllEle.forEach((ele, index) => {
        // Reset each phase to its initial CSS state. Prevents class overlap and class duplication.
        resetPhaseInitialState(ele);

        // Apply an inactive class on the phases that are not focused.
        if (currentEleIndex !== index) {
            PL_utils.addClass('addiction-cycle__phase--inactive', ele);
        }
    });

    // Give the current focus element an active class and display the expanded copy.
    PL_utils.addClass('addiction-cycle__phase--active', element);
};

/*
 * Reset the phases to its initial state on page load.
 */
const resetPhaseInitialState = (element) => {
    PL_utils.removeClass('addiction-cycle__phase--active', element);
    PL_utils.removeClass('addiction-cycle__phase--inactive', element);
};

const resetAllPhasesInitialState = () => {
    addictionPhasesAllEle.forEach((ele) => {
        const elementTrigger = ele.querySelector('[data-trigger]');
        accordion.collapse(elementTrigger);
        resetPhaseInitialState(ele);
    });
};

export default () => {
    if ( !document.querySelector('.page-oud-video') ) {
        document.addEventListener('accordionBeforeExpand', () => {
            resetAllPhasesInitialState();
        });

        // When we expand an accordion, have the screen reader automatically read
        // the contents.
        document.addEventListener('accordionAfterExpand', (e) => {
            // Set focus to the panel interior. If you set focus to the panel element
            // itself, the screen reader won't read the contents..

            const id = e.detail.trigger.getAttribute('aria-controls');
            const el_panel = document.querySelector('#' + id + ' .content');
            el_panel.setAttribute('tabindex', '-1');
            el_panel.focus();

            // Add class to indicate the container is now expanded.
            const el_circle = e.detail.trigger.closest('.addiction-cycle__phase');
            applyActiveClass(el_circle);
        });

        // When we click a 'less' button, collapse the accordion and set focus
        // back to the accordion trigger.
        document.addEventListener('click', (e) => {
            const element = e.target.closest('.addiction-cycle__phase-btn--close');
            if (!element) {
            // We didn't click the 'less' button in a circle.
                return;
            }

            const el_panel = element.closest('[data-panel]');

            const id = el_panel.getAttribute('aria-labelledby');
            const el_trigger = document.getElementById(id);

            // Close the accordion.
            accordion.collapse(el_trigger);

            //set state back to initial
            resetAllPhasesInitialState();

            // Set focus back to the trigger.
            el_trigger.focus();
        }, false);

        document.addEventListener('accordionAfterCollapse', (e) => {
            // Add class to indicate the container is now collapsed.
            const el_circle = e.detail.trigger.closest('.addiction-cycle__phase');

            resetPhaseInitialState(el_circle);
        });
    }
};

